/* @flow */
import * as t from './actionTypes';

const InitialState: {
  newFareEstimate: { useCase: string, originId: string, destinationId: string },
} = {
  newFareEstimate: {
    useCase: null,
    originId: null,
    destinationId: null,
  },
};

export default function fareEstimates(state: Object = InitialState, action: Object) {
  switch (action.type) {
    case t.SET_NEW_FARE_ESTIMATE_USE_CASE:
      return {
        ...state,
        newFareEstimate: {
          ...state.newFareEstimate,
          useCase: action.useCase,
        },
      };
    case t.SET_NEW_FARE_ESTIMATE_ORIGIN_ID:
      return {
        ...state,
        newFareEstimate: {
          ...state.newFareEstimate,
          originId: action.originId,
        },
      };
    case t.SET_NEW_FARE_ESTIMATE_DESTINATION_ID:
      return {
        ...state,
        newFareEstimate: {
          ...state.newFareEstimate,
          destinationId: action.destinationId,
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/fare-estimates/reducer.js